import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import {
  Container, Typography, Box, CircularProgress, Alert, Paper, Button
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useAuth } from '../contexts/AuthContext';
import WorkflowRunForm from '../components/workflow/WorkflowRunForm';
import billingApi from '../services/billingApi';

export default function WorkflowRunPublic() {
  const { workflowId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  const [definition, setDefinition] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (workflowId) loadWorkflow();
  }, [workflowId]);

  async function loadWorkflow() {
    setLoading(true);
    try {
      const data = await billingApi.get(`/api/workflows/${workflowId}`);
      setDefinition(data.definition);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <Container maxWidth="sm" sx={{ py: 6, textAlign: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  if (error || !definition) {
    return (
      <Container maxWidth="sm" sx={{ py: 6 }}>
        <Alert severity="error">{error || 'This action is not available'}</Alert>
        <Button sx={{ mt: 2 }} onClick={() => navigate('/subscriptions')}>Back to Subscriptions</Button>
      </Container>
    );
  }

  // Pre-fill from auth context + URL params
  const prefilledData = {
    user_id: user?.id,
    email: user?.email,
  };

  // If subscription ID passed via query param, pre-fill it
  const subscriptionId = searchParams.get('subscription');
  if (subscriptionId) {
    prefilledData.subscription_id = subscriptionId;
  }

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Button size="small" startIcon={<ArrowBackIcon />} onClick={() => navigate('/subscriptions')} sx={{ mb: 2 }}>
        Back to Subscriptions
      </Button>

      <Paper variant="outlined" sx={{ p: 3 }}>
        <Typography variant="h5" sx={{ mb: 0.5 }}>{definition.name}</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>{definition.description}</Typography>

        <WorkflowRunForm
          definition={definition}
          mode="customer"
          prefilledData={prefilledData}
          onExecuted={() => {}}
          showProgress
        />
      </Paper>
    </Container>
  );
}
